var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleAvatarPatientTicketMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "#FDD158"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1432_10086",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 97
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1432_10086)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1432_10086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5344 94.0555C79.5344 82.1086 69.8496 72.4238 57.9027 72.4238H38.8089C26.8621 72.4238 17.1772 82.1086 17.1772 94.0555V102.644C26.192 108.377 36.8814 111.711 48.3558 111.711C59.8302 111.711 70.5197 108.377 79.5344 102.644V94.0555Z",
    fill: "#CE569E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3134 64.1396V70.4779C55.3134 74.6624 52.2296 78.0546 48.4255 78.0546H48.2863C44.4823 78.0546 41.3984 74.6624 41.3984 70.4779V64.1396",
    fill: "#F8D19F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3984 68.6963C43.4893 69.5998 45.7753 70.1059 48.1755 70.1059H48.5363C50.9365 70.1059 53.2225 69.5998 55.3134 68.6963V65.8223H41.3984V68.6963Z",
    fill: "#F5BC8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7449 43.5963C28.3713 43.5963 27.8852 43.2004 27.6647 42.7165C27.4064 42.1496 27.3189 39.5435 27.4185 35.3862C27.553 29.7737 27.6833 28.6547 28.421 26.7739C28.8873 25.585 30.0456 23.5872 30.9949 22.3344C32.1008 20.8749 33.7353 19.368 35.5445 18.1401C37.0975 17.086 39.3523 15.8414 40.5551 15.3741C42.3155 14.6904 43.7502 14.5159 46.7377 14.5181C48.7791 14.5196 51.9079 15.2046 54.6638 15.2601C58.3799 15.3349 59.8326 14.5273 60.7432 15.2601C61.3326 16.0001 60.8326 18.1401 60.8326 19.5001C61.8326 21.0001 61.1524 19.9539 63.8677 22.6082C65.9358 24.6298 66.9235 25.9657 68.0113 28.2125C69.4226 31.1273 69.4414 31.2244 69.5895 36.3438C69.672 39.1935 69.5909 41.9493 69.4094 42.4679C69.2278 42.9864 68.7474 43.4587 68.3417 43.5175C67.9361 43.5762 67.2836 43.3899 66.8919 43.1034C66.3615 42.7156 66.1368 41.9915 66.0122 40.2688C65.8448 37.955 65.8448 37.955 63.3251 35.8965C61.9393 34.7644 60.2983 33.517 59.6784 33.1245C58.5514 32.4109 58.5514 32.4109 57.224 34.2586C56.4939 35.2748 55.217 36.7203 54.3863 37.4707C53.5557 38.2211 51.7147 39.3917 50.2953 40.0719C48.876 40.7521 46.5882 41.4987 45.2114 41.7309C43.1669 42.0758 42.2011 42.0487 39.9415 41.5832C38.4198 41.2697 35.9731 40.4071 34.5044 39.6662C33.0358 38.9254 31.6996 38.3324 31.5352 38.3484C31.3708 38.3645 31.1299 39.3315 30.9999 40.4973C30.8425 41.9092 30.5399 42.7804 30.0939 43.1066C29.7256 43.3759 29.1185 43.5963 28.7449 43.5963Z",
    fill: "#252546"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.643 48.1816H30.7305C33.1213 48.1816 35.0595 46.2434 35.0595 43.8525V43.7651C35.0595 41.3742 33.1213 39.436 30.7305 39.436H30.643C28.2521 39.436 26.314 41.3742 26.314 43.7651V43.8525C26.314 46.2434 28.2521 48.1816 30.643 48.1816ZM65.9809 48.1816H66.0683C68.4592 48.1816 70.3974 46.2434 70.3974 43.8525V43.7651C70.3974 41.3742 68.4592 39.436 66.0683 39.436H65.9809C63.59 39.436 61.6518 41.3742 61.6518 43.7651V43.8525C61.6518 46.2434 63.59 48.1816 65.9809 48.1816Z",
    fill: "#F5BD8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.311 42.8901V48.5985C30.311 58.9831 38.3092 67.4015 48.1754 67.4015H48.5363C58.4024 67.4015 66.4006 58.9831 66.4006 48.5985V42.5171C66.4006 42.4984 66.4006 42.4797 66.4005 42.4611C66.2022 42.003 66.0884 41.3228 66.0122 40.2685C65.9407 39.2797 65.8997 38.7135 65.6796 38.2286C65.3846 37.5788 64.768 37.0751 63.3251 35.8963C61.9393 34.7642 60.2983 33.5168 59.6784 33.1243C58.5514 32.4107 58.5514 32.4107 57.224 34.2584C56.4939 35.2746 55.217 36.72 54.3863 37.4705C53.5557 38.2209 51.7147 39.3915 50.2953 40.0717C48.876 40.7519 46.5882 41.4985 45.2114 41.7307C43.1669 42.0755 42.2011 42.0485 39.9415 41.583C38.4198 41.2695 35.9731 40.4069 34.5044 39.666C33.0358 38.9251 31.6996 38.3321 31.5352 38.3482C31.3708 38.3643 31.1299 39.3313 30.9999 40.4971C30.8695 41.6665 30.6396 42.4649 30.311 42.8901Z",
    fill: "#F8D19F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.8796,
    cy: 46.3849,
    rx: 2.36347,
    ry: 2.36346,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7092,
    cy: 46.3849,
    rx: 2.36346,
    ry: 2.36346,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3873 61.3385H48.3092C46.1752 61.3385 44.4453 59.6085 44.4453 57.4746V57.4355H52.2511V57.4746C52.2511 59.6085 50.5212 61.3385 48.3873 61.3385Z",
    fill: "#F3B28E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1432_10086",
    x: 13.1772,
    y: 14.5181,
    width: 70.3569,
    height: 105.193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1432_10086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1432_10086",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleAvatarPatientTicketMessage);
export default __webpack_public_path__ + "static/media/male-avatar-patient-ticket-message.efd284d0492d83a89c8fbf8ca9fb211f.svg";
export { ForwardRef as ReactComponent };